<template>
	<div class="app-container">
		<el-form
			:model="searchData"
			:inline="true"
			label-width="140px"
			label-position="right"
			ref="searchData"
		>
			<el-form-item label="承运区域" prop="address">
				<el-row>
					<el-col :span="8">
						<el-select
							v-model="searchData.provinceCode"
							placeholder="请选择"
							clearable
							style="width: 100%"
							@change="provinceChangeFun"
						>
							<el-option
								v-for="item in provinceListNew"
								:key="item.provinceId"
								:label="item.province"
								:value="item.provinceId"
								style="width: 100%"
							>
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="8">
						<el-select
							v-model="searchData.cityCode"
							placeholder="请选择"
							clearable
							style="width: 100%"
							:disabled="!searchData.provinceCode"
							@change="cityChangeFun"
						>
							<el-option
								v-for="item in cityListNew"
								:key="item.cityId"
								:label="item.city"
								:value="item.cityId"
								style="width: 100%"
							>
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="8">
						<el-select
							v-model="searchData.countyCode"
							placeholder="请选择"
							clearable
							style="width: 100%"
							:disabled="!searchData.cityCode"
						>
							<el-option
								v-for="item in districtListNew"
								:key="item.countyId"
								:label="item.county"
								:value="item.countyId"
								style="width: 100%"
							/>

						</el-select>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="是否分配承运商" prop="isAllocate">
				<el-select
					v-model="searchData.isAllocate"
					placeholder="请选择"
					clearable
					style="width: 100%"
				>
					<el-option
						v-for="item in isAllocateOption"
						:key="item.key"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="承运商名称" prop="partnerName">
				<el-input
					v-model="searchData.partnerName"
					placeholder="请输入"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item label="组织编号" prop="partnershipId">
				<el-input
					v-model="searchData.partnershipId"
					placeholder="请输入"
					clearable
				></el-input>
			</el-form-item>
		</el-form>
		<div class="btn-group">
			<div class="row-bg">
				<el-button type="primary" size="medium" @click="batchDispatchMasterFun">批量分配承运商</el-button>
				<el-button type="primary" size="medium" @click="exportBtnFun" :loading="exportFlag">导出</el-button>
			</div>
			<div class="row-bg">
				<el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
				<el-button size="medium" @click="resetForm()">重置</el-button>
			</div>
		</div>

		<el-table
			ref="checktableData"
			:data="tableData"
			v-loading="tableLoading"
			:reserve-selection="true"
			center
			height="60vh"
		>
			<el-table-column label="操作" prop="action" width="120">
				<template slot-scope="scope">
					<el-link type="primary" @click="dispatchRowFun(scope.row)">分配</el-link>
				</template>
			</el-table-column>
			<el-table-column label="承运区域（省）" prop="province" min-width="140"></el-table-column>
			<el-table-column label="承运区域（市）" prop="city" min-width="140"></el-table-column>
			<el-table-column label="承运区域（区）" prop="county" min-width="140"></el-table-column>
			<el-table-column label="是否分配承运商" prop="isAllocate" min-width="140">
				<template slot-scope="scope">
					{{ scope.row.isAllocate == 1 ? '已分配' : '未分配' }}
				</template>
			</el-table-column>
			<el-table-column label="承运商名称" prop="partnerName" min-width="140"></el-table-column>
			<el-table-column label="组织编号" prop="partnershipId" min-width="120"></el-table-column>
			<el-table-column label="组织类型" prop="partnershipTypeDesc" min-width="140"></el-table-column>
		</el-table>
		<div class="pagination-container">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes,prev, pager, next,jumper"
				:current-page.sync="pagination.currPage"
				:page-size="pagination.pageSize"
				:page-sizes="[10, 20, 30, 50]"
				:total="total"
			>
			</el-pagination>
		</div>
		<CarrierDialog ref="carrierDialogRef" @dispatch-success="handleSearch"></CarrierDialog>

		<commonBath
      ref="batchCommonRef"
      @opera-success="handleSearch"
      :errUrl="'/autoapp-default-server-recovery/api/jd/partnerManagementBond/downLoadJdPartnerAllocateFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/jd/partnerManagementBond/downLoadJdTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/jd/partnerManagementBond/importJdPartnerAllocateRegion'"
      :title="'批量添加京东承运商区域分配'"
      :uploadTitle="'导入京东承运商区域'"
    ></commonBath>
	</div>
</template>
<script>
import CarrierDialog from './components/CarrierDialog.vue'
import commonBath from "@/views/oldForNewService/components/commonBath.vue"
import jdProvinceCity from "./mixins/jdProvinceCity.js"
export default {
	components: {
		CarrierDialog,
		commonBath
	},
	mixins: [jdProvinceCity],
	data() {
		return {
			searchData: {
				provinceCode: undefined,
				cityCode: undefined,
				countyCode:undefined,
				isAllocate: undefined,
				carryName: undefined,
				partnershipId: undefined,
			},
			provinceList: [],
			cityList: [],
			isAllocateOption: [
				{
					label: '已分配',
					value: 1,
				},
				{
					label: '未分配',
					value: 0,
				},
			],
			tableData: [],
			tableLoading: false,
			pagination: {
				currPage: 1,
				pageSize: 10,
			},
			total: 0,
			exportFlag: false
		}
	},
	created() {
		this.handleSearch()
	},
	methods: {
		// 省改变
		provinceChangeFun () {
			this.searchData.cityCode = undefined
			const provinceCode = this.searchData.provinceCode
			this.getTblCityNew(provinceCode)
		},
		// 市改变
		cityChangeFun () {
			this.searchData.countyCode = undefined
			const provinceCode = this.searchData.provinceCode
			const cityCode = this.searchData.cityCode
			this.getTblCountyNew(provinceCode, cityCode)
		},
		// 查询
		handleSearch() {
			this.pagination.currPage = 1
			this.getList()
		},
		// 清空
		resetForm() {
			this.searchData = {
				provinceCode: undefined,
				cityCode: undefined,
				isAllocate: undefined,
				carryName: undefined,
				partnershipId: undefined,
			}
		},
		// 分配
		dispatchRowFun(rowData) {
			this.$refs.carrierDialogRef.opendDialog('dispatch', rowData)
		},
		// 页码改变
		handleSizeChange(val) {
			this.pagination.currPage = 1
			this.pagination.pageSize = val
			this.getList()
		},
		handleCurrentChange() {
			this.getList()
		},
		getList() {
			const url =
				'/autoapp-default-server-recovery/api/jd/partnerManagementBond/pageJdPartnerRegionAllocate'
			const params = {
				...this.searchData,
				...this.pagination
			}
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					// console.log('res===', res)
					this.tableData = res.data || []
					this.total = res.total || 0
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 批量
		batchDispatchMasterFun () {
			this.$refs.batchCommonRef.openDialog()
		},
		// 导出
		exportBtnFun () {
			this.exportFlag = true
			setTimeout(() => {
				this.exportFlag = false
			}, 1200)
			const url = "/autoapp-default-server-recovery/api/jd/partnerManagementBond/exportJdPartnerAllocateRegion"
			const title = "承运商分配列表导出"
			const params = {
				...this.searchData,
				...this.pagination
			}

      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
		}
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.btn-group {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 14px;
}
.row-bg{
	display: flex;
	flex-direction: row;
	align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/carrierAllocation.vue